/**
 * Configuracion publica de la app Cumple (ADR-016, S4-A).
 *
 * Vite expone import.meta.env.VITE_* en build. Para que el PWA pueda
 * leer URLs sin hardcoding, se centralizan aqui los defaults; en
 * staging/produccion el pipeline inyecta los valores reales via
 * `VITE_MARKETING_URL` y `VITE_APP_URL` antes del `vite build`.
 *
 * En dev (vite dev) sin .env, los defaults apuntan al dominio
 * comercial; las rutas relativas siguen siendo `/api/v1/...` (mismo
 * origen, no requieren env).
 */
interface ImportMetaEnv {
  readonly VITE_MARKETING_URL?: string;
  readonly VITE_APP_URL?: string;
}

const env = import.meta.env as ImportMetaEnv;

export const config = {
  marketingUrl: env.VITE_MARKETING_URL ?? 'https://cumpleapp.com',
  appUrl: env.VITE_APP_URL ?? 'https://app.cumpleapp.com',
} as const;

/**
 * Devuelve el host de tenant compartido para un slug dado (ej. para
 * mostrar en el formulario de signup como preview de URL).
 */
export function tenantHostFor(slug: string): string {
  const appHost = new URL(config.appUrl).host;
  // app.cumpleapp.com → cumpleapp.com (un nivel arriba)
  const base = appHost.replace(/^app\./, '');
  return `${slug}.${base}`;
}
